import { render, staticRenderFns } from "./c-Statistics.vue?vue&type=template&id=8a3fedd4&"
import script from "./c-Statistics.vue?vue&type=script&lang=js&"
export * from "./c-Statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports